import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMapEvents } from 'react-leaflet';
import listeSecteurAlzonne from './liste_secteur_alzonne.json';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import InputDialog from './InputDialog';  // Assurez-vous d'importer votre composant InputDialog

// Manually set the default icon
const DefaultIcon = L.icon({
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

// This is necessary to apply the default icon settings globally
L.Marker.prototype.options.icon = DefaultIcon;

// let flag = true;

function ecartConsole(){
//   let i = 1;
//   if(flag){
//     listeSecteurAlzonne.forEach(endroit => {
//       if(endroit['Nom de la commune'] == "ST DENIS" && endroit['Type Lieu'] == "ECART"){
//         console.log(i + " " + endroit['Nom Lieu']);
//         i++;
//       }
//     });
//   }
//   flag = false;
}

const LeafletMapComponent = ({ onAddPoint, onRemovePoint, points = [] }) => {
  const [markers, setMarkers] = useState(points);
  const [isPopupClick, setIsPopupClick] = useState(false);
  const [showInputDialog, setShowInputDialog] = useState(false);
  const [newPointCoords, setNewPointCoords] = useState(null);

  useEffect(() => {
    setMarkers(points);
    ecartConsole();
  }, [points]);

  const MapEventHandler = () => {
    useMapEvents({
      click(event) {
        if (isPopupClick) {
          setIsPopupClick(false);
          return;
        }
        setNewPointCoords(event.latlng);
        setShowInputDialog(true);
      },
    });
    return null;
  };

  const handleConfirm = (name) => {
    if (newPointCoords && name.trim()) {
      const newMarker = { lat: newPointCoords.lat, lng: newPointCoords.lng, name };
      setMarkers([...markers, newMarker]);
      onAddPoint(newMarker);
    }
    setShowInputDialog(false);
    setNewPointCoords(null);
  };

  const handleCancel = () => {
    setShowInputDialog(false);
    setNewPointCoords(null);
  };

  const handleRemoveMarker = (index, e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsPopupClick(true);
    const markerToRemove = markers[index];
    const newMarkers = markers.filter((_, i) => i !== index);
    setMarkers(newMarkers);
    onRemovePoint(markerToRemove);
  };

  return (
    <>
      <MapContainer center={[43.2431, 2.1921]} zoom={10} style={{ height: "100%", width: "100%" }}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {markers.map((marker, index) => (
          <Marker key={index} position={[marker.lat, marker.lng]}>
            <Popup>
              {marker.name} <br />
              <button onClick={(e) => handleRemoveMarker(index, e)}>Supprimer</button>
            </Popup>
          </Marker>
        ))}
        <MapEventHandler />
      </MapContainer>
      
      {showInputDialog && (
        <InputDialog
          message=""
          placeholder="Entrez le nom du point."
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      )}
    </>
  );
};

export default LeafletMapComponent;
